exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-button{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-right: 10px;\n}\n\n.p-button {\n    margin-right: 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/area-restrita/planos/plano/pbdc-superavit/pbdc-superavit.component.css
// module id = ../../../../../src/app/area-restrita/planos/plano/pbdc-superavit/pbdc-superavit.component.css
// module chunks = main